const destinations = [
  { name: "United Kingdom & Ireland", context: "Legal and energy sector executives at London client meetings, Edinburgh conferences, Dublin financial summits", urgency: "Business travel often booked 2–4 weeks in advance on short client notice", icon: "ri-map-pin-2-line" },
  { name: "France & Mediterranean", context: "Heritage travel for Metairie's French-Creole community, Mediterranean cruises from European ports, Riviera leisure travel", urgency: "Mediterranean cruise bookings often advance-purchased with poor passport hygiene", icon: "ri-map-pin-2-line" },
  { name: "Mexico & Caribbean", context: "Metairie families on Caribbean cruises from New Orleans, Cancun resort vacations, Puerto Vallarta leisure trips", urgency: "Cruise deals trigger fast bookings — passport checks happen after, not before", icon: "ri-map-pin-2-line" },
  { name: "Germany & Netherlands", context: "Energy sector business travel to Hamburg, Rotterdam, and Düsseldorf; pharmaceutical and medical device industry meetings", urgency: "Industry event calendars drive booking windows that leave little lead time", icon: "ri-map-pin-2-line" },
  { name: "Italy & Spain", context: "Retiree Mediterranean tours, cultural travel for Metairie's Italian-American community, Barcelona and Rome leisure trips", urgency: "Retirement travel is often booked well in advance but passport checks get delayed", icon: "ri-map-pin-2-line" },
  { name: "Canada", context: "Business travel to Calgary energy sector offices, Toronto financial meetings, Montreal heritage tourism", urgency: "Energy sector meetings are frequently scheduled on compressed client timelines", icon: "ri-map-pin-2-line" },
];

const stats = [
  { stat: "15 Min", label: "from Metairie to MSY via I-10 — one of Louisiana's fastest airport access communities" },
  { stat: "2–4 Wks", label: "typical lead time for Metairie executive international travel bookings" },
  { stat: "Highest", label: "income and passport ownership rate among Jefferson Parish communities — active international travelers" },
  { stat: "Oct–Apr", label: "peak season for Metairie retiree Mediterranean cruise planning and European tour bookings" },
];

export default function MetairieDestinationsSection() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Local Travel Intelligence</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Where Metairie Travelers Go — And Why Passports Get Urgent
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            These are the destinations and travel patterns we see most from Metairie and Jefferson Parish clients. Understanding these local travel behaviors is part of why our document review catches issues before they derail your trip.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-14">
          {stats.map((s, i) => (
            <div key={i} className="bg-[#1A365D] rounded-lg p-6 text-center">
              <p className="font-serif text-3xl font-bold text-[#F6C344] mb-2">{s.stat}</p>
              <p className="text-white/60 text-xs leading-relaxed">{s.label}</p>
            </div>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-12">
          {destinations.map((d, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200 hover:border-[#F6C344] transition-all group">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#1A365D]/5 group-hover:bg-[#F6C344]/15 transition-colors flex-shrink-0">
                  <i className={`${d.icon} text-[#1A365D] group-hover:text-[#F6C344] transition-colors text-lg`}></i>
                </div>
                <h3 className="font-bold text-[#1A365D] text-sm">{d.name}</h3>
              </div>
              <p className="text-gray-500 text-sm leading-relaxed mb-3">{d.context}</p>
              <div className="flex items-start gap-2">
                <i className="ri-time-line text-[#F6C344] text-xs flex-shrink-0 mt-0.5"></i>
                <p className="text-gray-400 text-xs leading-relaxed italic">{d.urgency}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#1A365D]/5 flex-shrink-0">
              <i className="ri-links-line text-[#1A365D] text-xl"></i>
            </div>
            <div className="flex-1">
              <h3 className="font-bold text-[#1A365D] text-sm mb-1">Explore Other Louisiana Service Areas</h3>
              <p className="text-gray-500 text-sm leading-relaxed">
                We serve travelers across Louisiana with the same professional expedited passport processing. Looking for service in another community?
              </p>
            </div>
            <div className="flex flex-wrap gap-2 flex-shrink-0">
              {[
                { name: "New Orleans", href: "/new-orleans" },
                { name: "Kenner", href: "/kenner" },
                { name: "Mandeville", href: "/mandeville" },
              ].map((link) => (
                <a key={link.href} href={link.href} className="inline-flex items-center gap-1.5 bg-white hover:bg-[#1A365D] text-[#1A365D] hover:text-white border border-gray-200 hover:border-[#1A365D] font-medium text-xs px-3.5 py-2 rounded-md transition-all whitespace-nowrap">
                  {link.name} <i className="ri-arrow-right-line text-xs"></i>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}